window.addEventListener('DOMContentLoaded', () => {
  const omnibusWidget = document.querySelector('#omnibus-price, #sniffie-omnibus-price')
  const omnibusWidgetPrice = document.querySelector('.omnibus-price__price, .sniffie-omnibus-price__price')
  const priceOverride = document.querySelector("#custom-omnibus-price")
  const fullTextOverride = document.querySelector("#omnibus-full-text-override")

  if (omnibusWidget && fullTextOverride) {
    omnibusWidget.innerHTML = `<p class="price__omnibus">${fullTextOverride.innerText.trim()}</p>`
  } else if (priceOverride && omnibusWidgetPrice) {
    omnibusWidgetPrice.innerHTML = priceOverride.innerText
  }

  if (omnibusWidget) {
    setTimeout(() => {
      omnibusWidget.style.opacity = 1
    }, 25)
  }
}, { once: true })
